<!--  -->
<template>
  <div>
    <div class="cont_r_b11">
      <p>
        <img :src="images.kcp1">&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
        <img
          :src="images.kcp2"
        >
      </p>
      <p>
        <br>
      </p>
      <p>
        <span style="font-size:16.0pt;font-family:宋体;">
          <strong>铬矿</strong>
        </span>
      </p>
      <p>
        <span style="font-size:16.0pt;font-family:宋体;">
          <strong></strong>
        </span>
      </p>
      <table
        border="1"
        cellspacing="0"
        cellpadding="0"
        align="left"
        width="100%"
        style="width:100.0%;border:solid windowtext 1.0pt;"
      >
        <tbody>
          <tr>
            <td width="14%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <b>
                  <span style="font-size:12px;font-family:宋体;">等级</span>
                </b>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="42%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <b>
                  <span style="font-size:12px;font-family:'} ';">
                    36%
                    Cr
                  </span>
                </b>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="23%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <b>
                  <span style="font-size:12px;font-family:'} ';">
                    32%
                    Cr
                  </span>
                </b>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="19%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <b>
                  <span style="font-size:12px;font-family:'} ';">
                    42%
                    Cr
                  </span>
                </b>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="14%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">形状</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="42%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">块矿</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="23%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">块矿</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="19%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">精矿</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="14%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">Cr:Fe</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="42%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">1.4:1</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="23%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">1.28:1</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="19%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">1.37:1</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="14%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">P</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="42%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">0.01%</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="23%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">0.01%</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="19%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'Arial Narrow';">&nbsp;0.01%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="14%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">S</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="42%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'Arial Narrow';">0.02%</span>
                <span style="font-size:10pt;font-family:'Arial Narrow';"></span>
              </p>
            </td>
            <td width="23%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'Arial Narrow';">0.02%</span>
                <span style="font-size:10pt;font-family:'Arial Narrow';"></span>
              </p>
            </td>
            <td width="19%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'Arial Narrow';">&nbsp;0.02%</span>
              </p>
            </td>
          </tr>
          <tr>
            <td width="14%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:宋体;">粒度</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="42%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">10-300mm90% min</span>
              </p>
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">0-10mm10% max</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="23%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'} ';">10x100mm80% min</span>
                <span style="font-size:10.0pt;font-family:&quot;"></span>
              </p>
            </td>
            <td width="19%" valign="top" style="border:solid windowtext 1.0pt;">
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'Arial Narrow';">&nbsp;0-1mm</span>
              </p>
              <p style="text-align:center;">
                <span style="font-size:12px;font-family:'Arial Narrow';">90% min</span>
              </p>
            </td>
          </tr>
        </tbody>
      </table>
      <strong>
        <br>
      </strong>
      <p></p>
      <p>
        <span style="font-size:16.0pt;font-family:宋体;">
          <strong>
            <br>
            <br>
          </strong>
        </span>
      </p>
      <p>
        <br>
      </p>
      <p>
        <br>
      </p>
      <p>&nbsp;</p>
      <p>
        <span style="font-size:16.0pt;font-family:宋体;">
          <strong>锰矿</strong>
        </span>
      </p>
      <p>
        <span style="font-size:16.0pt;font-family:宋体;">
          <strong>
            <br>
          </strong>
        </span>
      </p>
      <p>
        <br>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      images: {
        kcp1: require("../../../assets/img/common/kcp1.jpg"),
        kcp2: require("../../../assets/img/common/kcp2.jpg")
      }
    };
  },

  components: {},

  methods: {}
};
</script>
<style lang='stylus' rel='stylesheet/stylus'>
</style>


// WEBPACK FOOTER //
// src/components/zh/product/kcp.vue